import {
    Component,
    OnInit,
    ViewEncapsulation,
    ElementRef
} from '@angular/core';
import { Router } from '@angular/router';
import {
    FormBuilder,
    FormControl,
    FormGroup,
    NgForm,
    FormsModule,
    Validators,
    AbstractControl
} from '@angular/forms';
import { DatatableComponent } from '../../../datatable.component';
import { CustomerService } from '../../../../../../services/customer.service';
import { DataService } from '../../../../../../_services/data.service';

declare var require: any;

@Component({
    selector: 'app-customer-list',
    templateUrl: './list-customer.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListCustomerComponent extends DatatableComponent implements OnInit {
    updateTrigger() {
        this.router.navigate(['/publisher/customer/update/' + this.id]);
    }
    deleteTrigger() {
        this.deleteRow(this.id);
    }
    buildDatatableParams() {
        this.columns = [
            {
                field: 'Name',
                title: 'Name',
                template: function(row) {
                    // callback function support for column rendering
                    return row.name;
                }
            },
            {
                field: 'Actions',
                width: 80,
                title: 'Actions',
                sortable: false,
                overflow: 'visible',
                textAlign: 'center',
                template: function(row, index, datatable) {
                    return (
                        '\
                    <button data-id="' +
                        row.id +
                        '" id="updateUser' +
                        row.id +
                        '" class="update-row m-datatable--on-layout-updated m-portlet__nav-link btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" title="Edit "><i class="la la-edit"></i></button>\
                    <button data-id="' +
                        row.id +
                        '" id="deleteUser' +
                        row.id +
                        '" (click)="deleteUser( ' +
                        row.email +
                        ')" class="delete-row m-portlet__nav-link btn m-btn m-btn--hover-danger m-btn--icon m-btn--icon-only m-btn--pill" title="Delete "><i class="la la-trash"></i></button>\
                '
                    );
                }
            }
        ];
    }

    constructor(
        private customerService: CustomerService,
        private dataService: DataService,
        protected el: ElementRef,
        private router: Router
    ) {
        super(el);
        this.datatableUrl =
            '/customers/list?filterId=' + this.dataService.publisherId;
    }

    getSelectedRows() {
        var ids = this.datatable
            .rows('.m-datatable__row--active')
            .nodes()
            .find('.m-checkbox--single > [type="checkbox"]')
            .map(function(i, chk) {
                return $(chk).val();
            });
        return ids;
    }

    deleteRow(id: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                this.customerService.delete(id).subscribe(data => {
                    this.datatable.load();
                    this.swalService.success('Customer successfully deleted.');
                });
            }
        });
    }

    ngOnInit() {
        this.buildDatatable();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/publisher/customer/list-customer/list-customer.component.ts